import { VerticalFilterBarProps } from "@kaltura/mediaspace-shared-search";
import Filter from "./filter/Filter";
import { StyledFilters, MultiSelection, StyledButtonsWrapper } from "./styled-components";
import { getDisabledFilters } from "@kaltura/mediaspace-shared-search";

const Filters = (props: VerticalFilterBarProps) => {
    const { filters: initialFilters, values, onChange } = props;

    const filters = getDisabledFilters(values, initialFilters);

    const multipleSelectionFilters = filters.filter((filter) => filter.multiSelection);
    const singleSelectionFilters = filters.filter((filter) => filter.singleSelection);

    return (
        <StyledFilters>
            <MultiSelection>
                {multipleSelectionFilters.map((filter) => (
                    <Filter key={filter.param} filter={filter} filterValues={values} onChange={onChange} />
                ))}
            </MultiSelection>
            <StyledButtonsWrapper>
                {singleSelectionFilters.map((filter, index) => (
                    <Filter key={filter.param} filter={filter} filterValues={values} onChange={onChange} />
                ))}
            </StyledButtonsWrapper>
        </StyledFilters>
    );
};

export default Filters;
